import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, User } from 'lucide-react';
import { useAppStore } from '../../contexts/AppStore';
import { Button } from '../ui/Button';

export const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const { user, setUser } = useAppStore();
  
  const handleLogout = () => {
    setUser(null);
    navigate('/login');
  };
  
  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-semibold text-gray-900">
            Bienvenido a OTRI Manager
          </h2>
          <p className="text-sm text-gray-600">
            Gestión integral de transferencia tecnológica
          </p>
        </div>
        
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2 px-4 py-2 bg-gray-100 rounded-lg">
            <User size={20} className="text-gray-600" />
            <span className="text-sm font-medium text-gray-900">
              {user?.name || 'Usuario'}
            </span>
          </div>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={handleLogout}
            className="flex items-center space-x-2"
          >
            <LogOut size={18} />
            <span>Cerrar Sesión</span>
          </Button>
        </div>
      </div>
    </header>
  );
};
